/**
 * author: Soumya Shreyas
 */
import React, { useState } from "react";
import { Button, ButtonGroup, ToggleButton } from "react-bootstrap";
import { withTranslation } from "react-i18next";
function TabFilter({ t, data, callbackValue }) {
  const [value, setValue] = useState("Supplier");
  const handleType = (e) => {
    setValue(e.currentTarget.value);
    callbackValue(e.currentTarget.value);
  };
  return (
    <>
      <ButtonGroup className="">
        {data.map((radio, idx) => (
          <ToggleButton
            key={idx}
            id={`radio-${idx}`}
            type="radio"
            variant="outline-primary"
            name="radio"
            value={radio.value}
            checked={value === radio.value}
            onChange={(e) => handleType(e)}
          >
            {radio.name}
          </ToggleButton>
        ))}
      </ButtonGroup>
    </>
  );
}

export default withTranslation()(TabFilter);
